
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"11.25","viewBox":"0 0 8.75 11.25","width":"8.75"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.625 10c0 .688.563 1.25 1.25 1.25h5c.687 0 1.25-.563 1.25-1.25V2.5h-7.5zM8.75.625H6.562L5.938 0H2.813l-.624.625H0v1.25h8.75z"}})])
          )
        }
      }
    